
import { connect } from "react-redux";
import  { LoginBox } from "./login-box";
import { navigatePath, pushPath } from "../../nav/actions";
import {resendOTP, setError, twoFAotp, UGMALogin} from "../login/actions";
import {dispatch_logout} from "../../app/logout-dispatch";

const mapDispatchToProps = dispatch => {
  return {
    setError: error => { dispatch(setError(error))},
    navigatePath: path => { dispatch(navigatePath(path))},
    pushPath: path => { dispatch(pushPath(path))},
    UGMALogin: (wlf_id, token) => { dispatch(UGMALogin(wlf_id, token)) },
    twoFAotp: (otp) => dispatch(twoFAotp(otp)),
    resendOTP: () => dispatch(resendOTP()),
    logout: () => { dispatch_logout(dispatch) },
  }
};

const mapStateToProps = state => {
  return {
    app: state.app,
    client: state.client,
    user: state.user,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginBox);
